import React, { Component } from 'react';
import { Link, withRouter, Redirect } from 'react-router-dom';
import REQUEST, { formBody } from './api/requests';
import { parseQueryString } from './utils/_helpers';
import Errors from './utils/errors';
import Success from './utils/success';

class Confirmation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: '',
      init: false,
      success: false,
    };
    this._cancelTokenDetails = null;
    this.confirming = this.confirming.bind(this);
  }

  componentDidMount() {
    this.confirming();
  }

  confirming() {
    const that = this;
    if (!this.state.init) {
      const href = window.location.href;
      const id = parseQueryString('id', href);
      const confirm = parseQueryString('confirm', href);
      
      this.setState({
        loading: true,
        init: true,
        error: '',
      });

      return new Promise((resolve, reject) => {
        if (id && confirm !== ( undefined && null)) {
          REQUEST.confirm(id, confirm, (cancel) => {
            that._cancelTokenDetails = cancel;
          })
            .then((res) => {
              if (res.data && res.status === 200 && res.data.status) {
                resolve(res);
                this.setState({
                  loading: false,
                  success: true,
                });
              }
              else if (res.data && res.status === 200 && !res.data.status) {
                reject();
                this.setState({
                  loading: false,
                  error: res.data.message || res.data.errorMessage,
                });
              }
              else {
                reject();
                this.setState({
                  loading: false,
                  error: Errors.default,
                });
              }
            })
            .catch((err) => {
              this.setState({
                loading: false,
                error: err.message,
              });
            });
        } else {
          setTimeout(() => {
            this.setState({
              loading: false,
              error: Errors.confirmationParamsWrong,
            })
          }, 500);
          reject();
        }
      });
    }
  }

  render() {

    const renderMsg = () => {
      if (this.state.error) {
        return this.state.error;
      } else if (this.state.success) {
        return Success.confirmed;
      }
      else {
        return 'Please wait a moment while we validate your confirmation code';
      }
    }

    return (
      <div className="confirmation container">
        <div className="confirmation-block">
          <h3 className={`block_title ${this.state.error ? 'error-helper': this.state.success ? 'confirmation_success' : ''}`}>{renderMsg()}</h3>
          {this.state.loading &&
            <div className="loader-wrapper">
              <div className="preloader-container">
                <div className="preloader-loader" />
              </div>
            </div>
          }
          {this.state.error && 
            <div>
              <div className="row confirmation_body">
                <div className="col-12">
                  <button
                    className="button button-form"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ init: false }, () => {
                        this.confirming();
                      });
                    }}
                  >
                    <span>Retry <i className="fas fa-sync-alt"></i></span> 
                  </button>
                </div>
              </div>
            </div>
          }
          {this.state.success && !this.state.loading && !this.state.error &&
            <div>
              <div className="row confirmation_body">
                <div className="col-12">
                  <button
                    className="button button-form"
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.history.replace('/');
                    }}
                  >
                    <span>Go to homepage <i className="fas fa-home"></i></span> 
                  </button>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
}

export default withRouter(Confirmation);


// WEBPACK FOOTER //
// ./src/Confirmation.js